// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCar = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M10 14.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0m5.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3" />,
    <path
      fillRule="evenodd"
      d="M19 4H5l-2 8v9h2v-2h14v2h2v-9zM5.062 12L5 12.246V17h14v-4.754L18.938 12zm13.376-2H5.562l1-4h10.876z"
    />
  );
export default SvgIconCar;
